import { getLogger } from "./Logger";
import { getUserSettings } from "./Settings";

const log = getLogger("core.LogicResponsibilityFiltering");

export class LogicResponsibilityFiltering {
    private static getResponsibilityCodes(): string[] {
        return getUserSettings()?.responsibility_codes;
    }

    public static userHasResponsibility(testCodes: string[]): boolean {
        const userRfCodes = this.getResponsibilityCodes();
        log.debug("Evaluating if user has responsibility using Test Codes: %o  User RF Codes: %o", testCodes, userRfCodes);
        if (userRfCodes == null) { //null indicates that the user is not a filtered user
            log.debug("User is not an RF filtered user")
            return true;
        }
        if (testCodes != null) {
            for (const testCode of testCodes) {
                if (userRfCodes.includes(testCode))
                    return true;
            }
        }
        return false;
    }
}